/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import EZUIKit from 'ezuikit-js';
// import { useStore } from '@/store';
import { useMonitorList } from './hooks/useMonitor';
import { addFocusMonitor, cancelFocusMonitor } from '@/service/Monitor';
export default defineComponent({
  name: 'Monitor',
  components: {},
  setup: function setup() {
    // const store = useStore();
    // const route = useRoute();
    // const router = useRouter();
    var curSiderbarIndex = ref(0);
    var _useMonitorList = useMonitorList(),
      _useMonitorList2 = _slicedToArray(_useMonitorList, 3),
      monitorData = _useMonitorList2[0],
      loading = _useMonitorList2[1],
      getMonitorListAsync = _useMonitorList2[2];
    var monitorList = ref([]);
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMonitorListAsync();
          case 2:
            if (monitorData.value.recordList[1]) {
              curSiderbarIndex.value = 1;
              monitorList.value = monitorData.value.recordList[1]['monitorList'];
              initMonitorList();
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var siderbar = computed(function () {
      return monitorData.value.recordList;
    });
    var siderbarClick = function siderbarClick(index, name) {
      closePlayer();
      curSiderbarIndex.value = index;
      monitorData.value.recordList.map(function (item) {
        if (item.cate_name == name) {
          monitorList.value = item.monitorList;
          initMonitorList();
        }
      });
    };
    var handleFocus = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item, index) {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              data = JSON.parse(JSON.stringify(item));
              if (!(item.focus === '1')) {
                _context2.next = 6;
                break;
              }
              _context2.next = 5;
              return cancelFocusMonitor({
                monitoringId: item.id
              });
            case 5:
              data.focus = '0';
            case 6:
              if (!(item.focus === '0')) {
                _context2.next = 10;
                break;
              }
              _context2.next = 9;
              return addFocusMonitor({
                monitoringId: item.id
              });
            case 9:
              data.focus = '1';
            case 10:
              monitorList.value.splice(index, 1, data);
              closePlayer();
              _context2.next = 14;
              return getMonitorListAsync();
            case 14:
              initMonitorList();
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 17]]);
      }));
      return function handleFocus(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 初始化监控播放
    var initMonitorList = function initMonitorList() {
      if (player) {
        player.stop();
      }
      monitorList.value.map(function (item) {
        item.isPlayer = false;
      });
    };
    var player;
    // 记录播放监控的索引  用于点击不是当前索引时用来关闭索引的监控播放
    var prevPlayerIndex = 0;
    // 判断是否关闭播放
    var closePlayer = function closePlayer() {
      if (player) {
        player.stop();
        player = null;
        if (prevPlayerIndex) {
          var prevData = JSON.parse(JSON.stringify(monitorList.value[prevPlayerIndex - 1]));
          prevData.isPlayer = false;
          monitorList.value.splice(prevPlayerIndex - 1, 1, prevData);
          prevPlayerIndex = 0;
        }
      }
    };
    var handlePlay = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(item, index) {
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              data = JSON.parse(JSON.stringify(item));
              closePlayer();
              prevPlayerIndex = index + 1;
              data.isPlayer = true;
              monitorList.value.splice(index, 1, data);
              _context3.next = 8;
              return nextTick();
            case 8:
              player = new EZUIKit.EZUIKitPlayer({
                audio: 0,
                autoplay: 1,
                id: "video-container-".concat(item.id),
                accessToken: monitorData.value.accessToken,
                url: "ezopen://open.ys7.com/".concat(item.device_serial, "/").concat(item.channel_no, ".hd.live"),
                template: 'simple',
                dblClickFullscreen: false,
                handleSuccess: function handleSuccess(res) {
                  console.log(res);
                }
              });
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 11]]);
      }));
      return function handlePlay(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();
    // 暂停当前播放
    var handlePause = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(item, index) {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = JSON.parse(JSON.stringify(item));
              prevPlayerIndex = 0;
              data.isPlayer = false;
              player = null;
              monitorList.value.splice(index, 1, data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function handlePause(_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }();
    var fullPlayer;
    var isFullePlayer = ref(false);
    // ----- 全屏 -----
    var handleFullScreen = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(item) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              closePlayer();
              _context5.prev = 1;
              isFullePlayer.value = true;
              _context5.next = 5;
              return nextTick();
            case 5:
              fullPlayer = new EZUIKit.EZUIKitPlayer({
                audio: 0,
                autoplay: 1,
                id: "full-video-container",
                accessToken: monitorData.value.accessToken,
                url: "ezopen://open.ys7.com/".concat(item.device_serial, "/").concat(item.channel_no, ".hd.live"),
                template: 'simple',
                dblClickFullscreen: false,
                handleSuccess: function handleSuccess(data) {
                  console.log(data);
                },
                fullScreenCallBack: function fullScreenCallBack(data) {
                  console.log('全屏状态变化', data);
                  // data 中可能包含全屏状态信息
                  // 可以根据 data 判断是进入还是退出全屏
                }
              });
              _context5.next = 8;
              return nextTick();
            case 8:
              fullPlayer.fullScreen();
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](1);
              console.error('[VideoPlayer] 全屏失败:', _context5.t0);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 11]]);
      }));
      return function handleFullScreen(_x7) {
        return _ref5.apply(this, arguments);
      };
    }();
    // 关闭全屏操作
    var closeFullScreen = function closeFullScreen() {
      fullPlayer.cancelFullScreen();
      fullPlayer.stop();
      fullPlayer = null;
      isFullePlayer.value = false;
    };
    var handleImgError = function handleImgError(img) {
      img.style.display = 'none';
      var fallback = img.nextElementSibling;
      if (fallback) {
        fallback.style.display = 'flex';
      }
    };
    return {
      siderbar: siderbar,
      curSiderbarIndex: curSiderbarIndex,
      siderbarClick: siderbarClick,
      loading: loading,
      monitorList: monitorList,
      handleFocus: handleFocus,
      handlePlay: handlePlay,
      handlePause: handlePause,
      handleFullScreen: handleFullScreen,
      closeFullScreen: closeFullScreen,
      isFullePlayer: isFullePlayer,
      handleImgError: handleImgError
    };
  }
});